import { useDocumentPrintTableColumnInfo } from './ColumnInfo';
import { DataTable } from '@/Components/DataTable/DataTable';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { documentPrintModalActions } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { DocumentInfoForPrintModel } from '@/Models/DocumentInfoModel';

function SelectDocumentTableComponent() {
  const dispatch = useDispatch();

  const columnInfos = useDocumentPrintTableColumnInfo();
  const documentNumbersInfo = useSelector(documentPrintModalSelectors.documentNumbersInfo);

  return (
    <DataTable<DocumentInfoForPrintModel>
      rows={documentNumbersInfo}
      rowKey={'documentNumber'}
      columnInfos={columnInfos}
      filterOptions={{
        needShowFiltersButton: false,
        needHeaderFilter: false,
        needColumnChooser: false,
        showFilterBuilder: false,
        needGlobalSearchPanel: false,
        needClearFiltersButton: false,
      }}
      editOptions={{
        needEditing: false,
      }}
      selectOptions={{
        showCheckBoxesMode: 'onClick',
        onSelectedRowsChanged(data) {
          dispatch(documentPrintModalActions.setSelectedDocumentNumbers(data));
        },
      }}
      defaultOptions={{
        showPagination: false,
      }}
      exportOptions={{
        needExport: false,
        exportFileName: '',
      }}
    />
  );
}

export const SelectDocumentTable = React.memo(SelectDocumentTableComponent);
